import script from "./WLX2DNoWorker.vue?vue&type=script&setup=true&lang=js"
export * from "./WLX2DNoWorker.vue?vue&type=script&setup=true&lang=js"

import "./WLX2DNoWorker.vue?vue&type=style&index=0&id=588ddb7b&scoped=true&lang=css"

import exportComponent from "D:\\yh\\工厂\\code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588ddb7b"]])

export default __exports__